import { render, staticRenderFns } from "./allRecipientList.vue?vue&type=template&id=770de239&scoped=true"
import script from "./allRecipientList.vue?vue&type=script&lang=js"
export * from "./allRecipientList.vue?vue&type=script&lang=js"
import style0 from "./allRecipientList.vue?vue&type=style&index=0&id=770de239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770de239",
  null
  
)

export default component.exports